import { ControlledRadioGroup } from "@dune/ui";
import { useFormContext, useWatch } from "react-hook-form";
import SirenSocietyForm from "../brokers/constructionSites/SirenClientForm";

const GFARealEstateSocietyContainer = () => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const isRealEstateSocietyDifferentThanMOA = useWatch({
		control,
		name: "isRealEstateSocietyDifferentThanMOA",
	});

	const radioItems = [
		{
			id: "is-real-estate-different-moa-radio",
			value: "true",
			label: "Oui",
		},
		{
			id: "is-real-estate-same-moa-radio",
			value: "false",
			label: "Non",
		},
	];

	return (
		<div className="flex flex-col gap-4">
			<div className="border rounded-lg p-4 flex flex-col gap-8">
				<ControlledRadioGroup
					control={control}
					name="isRealEstateSocietyDifferentThanMOA"
					label="Le promoteur est-il différent du Maître d'Ouvrage ?"
					items={radioItems}
					className="flex w-1/2"
					error={errors.isRealEstateSocietyDifferentThanMOA?.message?.toString()}
				/>
				{isRealEstateSocietyDifferentThanMOA === "true" && (
					<div className="flex flex-col gap-4 border-solid border-1 border-gray-200 rounded-lg p-4">
						<h1 className="text-[#144C65] text-lg font-medium">Promoteur</h1>
						<div className="flex flex-row gap-4">
							<SirenSocietyForm formKey="realEstateSociety" />
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default GFARealEstateSocietyContainer;
